import { AxiosError } from 'axios'
import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import { LoadingState, ValidationError } from '../../../types/commonTypes'
import { ApiLoadingState } from '../../../middleware/api/apiList'
import { AppDispatch, RootState } from '../../../stateStore'
import {
  GetJoineeById,
  GetUpComingJoineeList,
  UpComingJoineeList,
  UpComingJoineeListProps,
  UpComingJoineeListSliceState,
  UpdateUpComingJoineeList,
} from '../../../types/Recruitment/UpComingJoinList/UpComingJoinListTypes'
import UpComingJoinListApi from '../../../middleware/api/Recruitment/UpComingJoinList/UpComingJoinListApi'

const getUpConingJoinList = createAsyncThunk(
  'jobapplicant/getUpcomingJoineeList',
  async (props: UpComingJoineeListProps, thunkApi) => {
    try {
      return await UpComingJoinListApi.getUpComingJoinList(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const getJoineeById = createAsyncThunk(
  'jobapplicant/getJoineeById',
  async (joineeId: number, thunkApi) => {
    try {
      return await UpComingJoinListApi.getJoineeById(joineeId)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)
const updateNewJoineeThunk = createAsyncThunk(
  'jobapplicant/updateNewJoinee',
  async (props: UpdateUpComingJoineeList, thunkApi) => {
    try {
      return await UpComingJoinListApi.UpdateNewJoinee(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const deleteJoinee = createAsyncThunk<
  number | undefined,
  number,
  {
    dispatch: AppDispatch
    state: RootState
    rejectValue: ValidationError
  }
>('jobapplicant/deleteJoinee', async (joineeId, thunkApi) => {
  try {
    return await UpComingJoinListApi.deleteJoinee(joineeId)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status as ValidationError)
  }
})

export const initialUpComingJoinListState: UpComingJoineeListSliceState = {
  upComingJoineeListDetails: [],
  listSize: 0,
  isLoading: ApiLoadingState.idle,
  getUpComingJoineeList: {} as GetUpComingJoineeList,
  getJoineeById: {} as GetJoineeById,
  searchString: '',
  toggle: '',
}

const upComingJoinListSlice = createSlice({
  name: 'upComingJoinList',
  initialState: initialUpComingJoinListState,
  reducers: {
    setSearchString: (state, action) => {
      state.searchString = action.payload
    },
    setToggle: (state, action) => {
      state.toggle = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUpConingJoinList.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })

      .addCase(getUpConingJoinList.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.upComingJoineeListDetails = action.payload.list
        state.listSize = action.payload.size
      })
      .addCase(getJoineeById.fulfilled, (state) => {
        state.isLoading = ApiLoadingState.succeeded
      })
      .addCase(getJoineeById.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addCase(getJoineeById.rejected, (state) => {
        state.isLoading = ApiLoadingState.failed
      })
      .addMatcher(isAnyOf(getJoineeById.fulfilled), (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.getJoineeById = action.payload
      })
  },
})

const upComingJoinListThunk = {
  getUpConingJoinList,
  getJoineeById,
  deleteJoinee,
  updateNewJoineeThunk,
}

function isLoading(state: RootState): LoadingState {
  return state.upComingJoinList.isLoading
}
const upComingJoinList = (state: RootState): UpComingJoineeList[] =>
  state.upComingJoinList.upComingJoineeListDetails

const getJoineeDetails = (state: RootState): GetJoineeById =>
  state.upComingJoinList.getJoineeById

const listSize = (state: RootState): number => state.upComingJoinList.listSize

const searchValue = (state: RootState): string =>
  state.upComingJoinList.searchString

export const upComingJoinListSelectors = {
  isLoading,
  upComingJoinList,
  listSize,
  getJoineeDetails,
  searchValue,
}

export const upComingJoiningListService = {
  ...upComingJoinListThunk,
  actions: upComingJoinListSlice.actions,
  selectors: upComingJoinListSelectors,
}

export default upComingJoinListSlice.reducer
